import { route } from './lib/route'
import { DrugSearchConfiguration as Page } from './ui/DrugSearchConfiguration'

export const configurationRoute = route.update({ component: Page })

/** @deprecated remove after migration to tanstack */
export const DrugSearchConfiguration = Page
